import styled from "styled-components";
import { devices } from "../../FormEnrollmentNew.styles";

export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 40px 0px;
  background-color: rgb(246, 241, 238);
`;
  
export const EnrollmentDateHeadline = styled.p`
  font-size: 1.1em;
  margin-bottom: 0px;
  padding: 10px 16px;
  background-color: var(--color-petrol);
  border-radius: 20px;
  color: #fff;
  margin-bottom: 20px;
  width: 80%;
  @media ${devices.tablet} {
    width: fit-content;
  }
`;

export const ContentWrapper = styled.div`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  @media ${devices.tablet} {
    width: 70%;
  }
  @media ${devices.laptop} {
    max-width: 60%;
  }
  @media ${devices.laptopLdesktop} {
    width: 40%;
  }
`;

export const Headline = styled.h1`
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 12px;
  @media ${devices.tablet} {
    font-size: 32px;
  }
`;

export const Body = styled.div`
  padding: 20px 16px 0px 16px;
  border-radius: 8px;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-left: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
  @media ${devices.tablet} {
    padding: 25px 34px;
  }
`;

export const Heighlight = styled.p`
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 4px;
  @media ${devices.tablet} {
    font-size: 1.1em;
  }
`;

export const ParagraphContainer = styled.p`
  margin-bottom: 16px;
  font-size: 15px;
  @media ${devices.tablet} {
    margin-bottom: 32px;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 25px;
  @media ${devices.tablet} {
    width: 70%;
  }
  @media ${devices.laptop} {
    max-width: 60%;
  }
  @media ${devices.laptopLdesktop} {
    width: 50%;
  }
`;

export const Image = styled.img`
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  object-fit: cover;
`;

export const MobilePayOl = styled.ol`
  margin-bottom: 0px;
`;

export const MobilePayLi = styled.li`
  margin-bottom: 8px;
  list-style: disc;
  span {
    text-decoration: underline;
  }
`;

export const MobilePaySwipeImage = styled.img`
  width: 50px; 
`;

export const MobilePayImgDescription = styled.p`
  font-size: 16px;
  margin-bottom: 0px;
`;

export const MobilePayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-lightblue);
  border-radius: 12px;
  gap: 16px;
  width: 216px;
  padding: 12px;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const CTA = styled.a`
  margin-top: 16px;
`;

export const LotteryContainer = styled.div`
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  border-left: 1px solid rgb(233, 233, 233);
  border-right: 1px solid rgb(233, 233, 233);
  border-bottom: 1px solid rgb(233, 233, 233);
  margin-top: 20px;
  display: flex;
  padding: 20px 16px;
  @media ${devices.tablet} {
    padding: 25px 34px;
  }
`;

export const LotteryImgContainer = styled.div`
`;

export const LotteryContentContainer = styled.div`
`;

export const LotteryIcon = styled.img`
  padding-right: 12px;
  width: 100px;
  @media ${devices.tablet} {
    width: auto;
  }
`;

export const SubHeadline = styled.h3` 
  font-size: 14px;
  margin-bottom: 6px;
  text-transform: uppercase;
  color: var(--color-blue-700);
  font-weight: 500;
  letter-spacing: 1px;
`;

export const Gift = styled.span`
    font-size: 20px;
    margin-left: -5px;
    padding-right: 2px;
`;

